import { RadioGroup } from '@headlessui/react';
import type { ElementType } from 'react';

import Props from '@/components/@base/input/radio/option/type';

const DEFAULT_OPTION_TAG = 'div';
export default function RadioOption<TTag extends ElementType = typeof DEFAULT_OPTION_TAG>({
  children,
  value = '',
  ...props
}: Props<TTag>) {
  return (
    // @ts-ignore
    <RadioGroup.Option value={value} {...props}
      className="
        outline-none
        focus:outline-none
        focus-visible:outline-none
        ring-0
        focus:ring-0
        focus-visible:ring-0
      ">
      {children}
    </RadioGroup.Option>
  );
}
